import classNames from 'classnames';

import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import useContentStyles from './Content/styles';
import useScrollStyles from './Scroller/styles';
import useStyles from './styles';

function HeaderBannerWithDynamicSliderFallback() {
  const styles = useStyles();
  const contentStyle = useContentStyles();
  const scrollStyle = useScrollStyles();
  return (
    <BannerCenteredContent className={styles.root}>
      <div
        className={classNames(contentStyle.root, contentStyle.fallbackParent)}
        data-testid="HeaderBannerWithDynamicSliderFallback-test"
      >
        <div className={contentStyle.logo}>
          <i className="skeleton" />
        </div>
        <div className={classNames(contentStyle.title, contentStyle.fallbackTitle)}>
          <i className="skeleton" />
        </div>
        <div className={classNames(contentStyle.fallbackDescription, contentStyle.description)}>
          <i className="skeleton" />
        </div>
        <div className={classNames(contentStyle.action, contentStyle.actionFallback)}>
          <i className="skeleton" />
        </div>
      </div>

      <div className={scrollStyle.root}>
        <div className={scrollStyle.container}>
          <div className={scrollStyle.controls}>
            <i className="skeleton" />
          </div>
          <div className={scrollStyle.imagesOuterWrapper}>
            <div className={scrollStyle.imagesWrapper}>
              {[...Array(5)].map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className={scrollStyle.imageHolder} key={index}>
                  <i className="skeleton" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </BannerCenteredContent>
  );
}

export default HeaderBannerWithDynamicSliderFallback;
